import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Area 
export const getAreas = createAsyncThunk("area/get-area", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/operations/app/v1/get-area`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        return response;
    } catch (error) {
        console.error('Error fetching Areas - ', error);
        throw error;
    }
})


